import { translate as t } from '@thoughtspot/i18n';
export const extendActionOnClick = (actions, setIsPopoverOpen, data, iconToggleConfig) => {
    return actions.map((actionMenuItemGroup) => ({
        ...actionMenuItemGroup,
        items: actionMenuItemGroup.items.map((actionMenuItem) => ({
            ...actionMenuItem,
            onClick: (event) => {
                // Handle icon toggle if config is provided
                if (iconToggleConfig) {
                    const newToggleState = !iconToggleConfig.currentState;
                    iconToggleConfig.setState(newToggleState);
                    if (actionMenuItem.onClick && event) {
                        const extendedEvent = {
                            ...event,
                            data: {
                                ...data,
                                isIconActive: newToggleState,
                            },
                        };
                        actionMenuItem.onClick(extendedEvent);
                    }
                }
                else {
                    // Regular action handling
                    if (actionMenuItem.onClick && event) {
                        const extendEvent = {
                            ...event,
                            data: data || actionMenuItem,
                        };
                        actionMenuItem.onClick(extendEvent);
                    }
                    setIsPopoverOpen(false);
                }
            },
        })),
    }));
};
export const getSortAscendingAction = (actionMenuItemHandler) => {
    const { id, label, handler, icon } = actionMenuItemHandler;
    return {
        id,
        label: label || t('ObjectTable.column.sort.ascending'),
        onClick: (event) => {
            if (handler) {
                handler(event);
            }
        },
        icon: icon || undefined,
    };
};
export const getSortDescendingAction = (actionMenuItemHandler) => {
    const { id, label, handler, icon } = actionMenuItemHandler;
    return {
        id,
        label: label || t('ObjectTable.column.sort.descending'),
        onClick: (event) => {
            handler(event);
        },
        icon: icon || undefined,
    };
};
export const getFilterAction = (actionMenuItemHandler) => {
    const { id, label, handler } = actionMenuItemHandler;
    return {
        id,
        label: label || t('ObjectTable.column.filter'),
        onClick: (event) => {
            handler(event);
        },
    };
};
export const getShareAction = (actionMenuItemHandler) => {
    const { id, data, label, handler, index, itemDisabled, itemDisabledTooltip, itemTooltip, dataTestId, } = actionMenuItemHandler;
    return {
        id,
        data,
        label: label || t('SHARE'),
        onClick: (event) => {
            handler(event, index);
        },
        itemDisabled,
        itemDisabledTooltip,
        itemTooltip,
        dataTestId,
    };
};
export const getTagsAction = (tags, handler) => {
    return tags.map((tag) => ({
        id: tag,
        label: tag,
        onClick: (event) => {
            handler(event);
        },
    }));
};
//# sourceMappingURL=object-table-action.util.js.map